import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const bodypartsAdapter = createEntityAdapter({})

const initialState = bodypartsAdapter.getInitialState()

export const bodypartsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getBodyparts: builder.query({
            query: () => ({
                url: 'exercises/bodyparts',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedBodyparts = responseData.map(bodypart => {
                    bodypart.id = bodypart._id
                    return bodypart
                });
                return bodypartsAdapter.setAll(initialState, loadedBodyparts)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Bodypart', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Bodypart', id }))
                    ]
                } else return [{ type: 'Bodypart', id: 'LIST' }]
            }
        }),
        addNewBodypart: builder.mutation({
            query: initialBpData => ({
                url: 'exercises/bodyparts',
                method: 'POST',
                body: {
                    ...initialBpData,
                }
            }),
            invalidatesTags: [
                { type: 'Bodypart', id: "LIST" }
            ]
        }),
        updateBodypart: builder.mutation({
            query: initialBpData => ({
                url: 'exercises/bodyparts',
                method: 'PATCH',
                body: {
                    ...initialBpData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Bodypart', id: arg.id }
            ]
        }),
        deleteBodypart: builder.mutation({
            query: ({ id }) => ({
                url: `exercises/bodyparts`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Bodypart', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetBodypartsQuery,
    useAddNewBodypartMutation,
    useUpdateBodypartMutation,
    useDeleteBodypartMutation,
} = bodypartsApiSlice

// returns the query result object
export const selectbodypartsResult = bodypartsApiSlice.endpoints.getBodyparts.select()

// creates memoized selector
const selectbodypartsData = createSelector(
    selectbodypartsResult,
    bodypartsResult => bodypartsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllbodyparts,
    selectById: selectBodypartById,
    selectIds: selectBodypartIds
    // Pass in a selector that returns the bodyparts slice of state
} = bodypartsAdapter.getSelectors(state => selectbodypartsData(state) ?? initialState)